import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

signInResetPasswordFormStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        justify-content: space-evenly;
                    `,
                    css`
                        justify-content: space-evenly;
                    `,
                    null,
                    null,
                    null,
                ],
                "minMax",
            )}
    `,
};

signInResetPasswordFormStyles.cancelButton = {
    color: "primary",
    variant: "primary",
    css: css`
        margin-right: 10px;
        border-radius: 25px;
        border: 1px solid ${COLORS.background.black};
        background-color: ${COLORS.background.base};
        > span {
            color: ${COLORS.black} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${COLORS.background.black};
            background-color: ${COLORS.background.base};
        }
        > span {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: ${TYPOGRAPHY.size.smallest};
                        `,
                        css`
                            font-size: ${TYPOGRAPHY.size.smallest};
                        `,
                        null,
                        null,
                        null,
                    ],
                    "minMax",
                )}
        }
    `,
};

signInResetPasswordFormStyles.sendButton = {
    css: css`
        border-radius: 25px;
        border: 1px solid ${getColor("warning")};
        background-color: ${getColor("warning")};
        > span {
            color: ${getColor("info.contrast")} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${getColor("warning.contrast")};
            background-color: ${getColor("warning.contrast")};
        }
        > span {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: ${TYPOGRAPHY.size.smallest};
                        `,
                        css`
                            font-size: ${TYPOGRAPHY.size.smallest};
                        `,
                        null,
                        null,
                        null,
                    ],
                    "minMax",
                )}
        }
    `,
};
